export default __webpack_public_path__ + "static/geetajayanti5-74650e3919c229417d9ea97ea8ab6533.jpg";